import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import Tooltip from '#components/Elements/Tooltip/Tooltip';
import Button from '#components/Elements/Button/Button';
import TextLink from '#components/Elements/TextLink/TextLink';
import CheckIcon from '#components/Elements/SVGIcon/CheckIcon';
import CopyIcon from '#components/Elements/SVGIcon/CopyIcon';
import styles from './ClipboardCopyButton.scss';

export default function ClipboardCopyButton({
  className,
  wrapperClassName,
  value,
  text,
  inverted,
  isIcon,
  iconSize,
  defaultTooltipText,
  tooltipLocation = 'southwest',
  test,
}) {
  const [copied, setCopied] = React.useState(false);
  const copy = useCallback(() => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1500);
  }, [value]);

  return (
    <Tooltip
      noWrap
      location={tooltipLocation}
      text={
        copied ? (
          <>
            <CheckIcon size="tiny" />
            <FormattedMessage
              defaultMessage="Copied"
              description="Copy instrument ID to clipboard button (copied state)"
            />
          </>
        ) : (
          defaultTooltipText ?? (
            <FormattedMessage
              defaultMessage="Copy to clipboard"
              description="Copy instrument ID to clipboard button"
            />
          )
        )
      }
      alwaysVisible={copied}
      wrapperClassName={wrapperClassName}
    >
      {isIcon ? (
        <Button
          icon
          size={iconSize}
          color="subdued"
          className={classNames(className, copied && styles.copied)}
          onClick={copy}
        >
          <CopyIcon />
        </Button>
      ) : (
        <TextLink
          className={className}
          inverted={inverted}
          onClick={copy}
          data-test={test}
        >
          {text || value}
        </TextLink>
      )}
    </Tooltip>
  );
}
